/* No app dependency. Read the native product type; retrieve EVERY server page
   after native price/availability/sort, then paginate matches, never only the visible page. */
(() => {
  const cache = new Map();
  let controller;
  let sequence = 0;
  const parser = new DOMParser();
  const parse = html => parser.parseFromString(html, 'text/html');
  function syncControls() {
    const params = new URLSearchParams(location.search);
    const type = params.get('mq_type') || '';
    document.querySelectorAll('[data-mq-type-value]').forEach(element => {
      const active = element.dataset.mqTypeValue === type;
      const next = new URLSearchParams(params);
      next.delete('page'); next.delete('filter.p.product_type'); next.delete('section_id');
      if (element.dataset.mqTypeValue) next.set('mq_type', element.dataset.mqTypeValue); else next.delete('mq_type');
      const url = `${location.pathname}${next.size ? '?' + next.toString() : ''}`;
      if (element.tagName === 'A') {
        element.href = url;
        element.classList.toggle('is-active', active);
        if (active) element.setAttribute('aria-current', 'true'); else element.removeAttribute('aria-current');
      } else if (element.tagName === 'OPTION') { element.value = url; element.selected = active; }
    });
  }
  async function renderPage(searchParams, event, updateHistory = true) {
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal; const request = ++sequence;
    const params = new URLSearchParams(searchParams);
    const type = params.get('mq_type') || '';
    const requestedPage = Math.max(1, Math.floor(Number(params.get('page')) || 1));
    params.delete('section_id'); params.delete('filter.p.product_type');
    FacetFiltersForm.searchParamsPrev = params.toString();
    if (updateHistory) FacetFiltersForm.updateURLHash(params.toString());
    syncControls();
    const status = document.getElementById('MqTypeFilterStatus');
    const gridContainer = document.getElementById('ProductGridContainer');
    gridContainer?.setAttribute('aria-busy', 'true');
    gridContainer?.querySelector('.collection')?.classList.add('loading');
    if (status) { status.textContent = 'Cargando productos…'; status.hidden = false; }
    try {
      const section = FacetFiltersForm.getSections()[0].section;
      const serverParams = new URLSearchParams(params);
      serverParams.delete('mq_type'); serverParams.delete('page');
      const key = location.pathname + '?' + serverParams.toString();
      async function fetchPage(page) {
        const query = new URLSearchParams(serverParams);
        query.set('section_id', section); query.set('page', page);
        const response = await fetch(`${location.pathname}?${query}`, { signal });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        if (!parse(html).getElementById('ProductGridContainer')) throw new Error('Missing collection');
        return html;
      }
      let firstHTML, cards;
      if (type && cache.has(key)) ({ firstHTML, cards } = cache.get(key));
      else {
        firstHTML = await fetchPage(type ? 1 : requestedPage);
        if (type) {
          const firstDoc = parse(firstHTML);
          const nativeGrid = firstDoc.getElementById('product-grid');
          const pages = Number(nativeGrid.dataset.mqPages);
          if (!Number.isFinite(pages)) throw new Error('Missing pagination metadata');
          const pageHTML = [firstHTML];
          let next = 2;
          // At most three requests in flight; never truncate a collection silently.
          await Promise.all(Array.from({ length: Math.min(3, Math.max(0, pages - 1)) }, async () => {
            while (next <= pages) { const page = next++; pageHTML[page - 1] = await fetchPage(page); }
          }));
          cards = pageHTML.flatMap(html => Array.from(parse(html).querySelectorAll('#product-grid > li[data-mq-product-type]')).map(card => ({ type: card.dataset.mqProductType, html: card.outerHTML })));
          cache.set(key, { firstHTML, cards });
          if (cache.size > 2) cache.delete(cache.keys().next().value);
        }
      }
      if (request !== sequence) return;
      const doc = parse(firstHTML);
      if (type) {
        const matches = cards.filter(card => card.type === type);
        const nativeGrid = doc.getElementById('product-grid');
        const perPage = Number(nativeGrid.dataset.mqPerPage) || 20;
        const totalPages = Math.max(1, Math.ceil(matches.length / perPage));
        const page = Math.min(requestedPage, totalPages);
        if (page !== requestedPage) {
          params.set('page', page);
          history.replaceState({ searchParams: params.toString() }, '', `${location.pathname}?${params}`);
        }
        nativeGrid.innerHTML = matches.slice((page - 1) * perPage, page * perPage).map(card => card.html).join('');
        if (!matches.length) {
          nativeGrid.innerHTML = '<li class="grid__item" style="grid-column:1/-1">No hay productos de este tipo con los filtros seleccionados.</li>';
        }
        doc.querySelector('.pagination-wrapper')?.remove();
        if (totalPages > 1) {
          const wrapper = doc.createElement('div'); wrapper.className = 'pagination-wrapper mq-type-pagination';
          const nav = doc.createElement('nav'); nav.className = 'pagination'; nav.setAttribute('aria-label', 'Paginación');
          const list = doc.createElement('ul'); list.className = 'pagination__list list-unstyled';
          const visible = new Set([1, totalPages, page - 1, page, page + 1].filter(n => n >= 1 && n <= totalPages));
          let previous = 0;
          for (const n of [...visible].sort((a,b) => a-b)) {
            if (previous && n - previous > 1) { const gap = doc.createElement('li'); gap.textContent = '…'; list.appendChild(gap); }
            const li = doc.createElement('li'), a = doc.createElement('a');
            const query = new URLSearchParams(params); query.set('page', n);
            a.href = `${location.pathname}?${query}`; a.textContent = n;
            a.className = 'pagination__item link' + (n === page ? ' pagination__item--current' : '');
            a.setAttribute('aria-label', 'Página ' + n);
            if (n === page) a.setAttribute('aria-current', 'page');
            li.appendChild(a); list.appendChild(li); previous = n;
          }
          nav.appendChild(list); wrapper.appendChild(nav); nativeGrid.after(wrapper);
        }
        ['ProductCount', 'ProductCountDesktop'].forEach(id => { const el = doc.getElementById(id); if (el) el.textContent = `${matches.length} productos`; });
      }
      const html = doc.documentElement.outerHTML;
      const typeFocus = document.getElementById('MqTypeFilterRegion')?.contains(document.activeElement);
      const selectFocus = document.activeElement?.matches('[data-mq-type-select]');
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      syncControls();
      if (typeFocus) document.querySelector(selectFocus ? '[data-mq-type-select]' : '[data-mq-type-link][aria-current="true"]')?.focus({ preventScroll: true });
      if (status) { status.hidden = true; status.textContent = ''; }
    } catch (error) {
      if (error.name === 'AbortError' || request !== sequence) return;
      if (status) { status.textContent = 'No se pudieron cargar todos los productos. Intenta nuevamente.'; status.hidden = false; }
      // Leave a visible, usable page and never present partial matches as complete results.
      gridContainer?.querySelector('.collection')?.classList.remove('loading');
      const grid = gridContainer?.querySelector('#product-grid');
      if (grid) grid.innerHTML = '<li class="grid__item" style="grid-column:1/-1">No se pudieron cargar los resultados. Selecciona Todas o vuelve a intentarlo.</li>';
      ['ProductCount', 'ProductCountDesktop'].forEach(id => { const el = document.getElementById(id); if (el) el.textContent = 'Resultados no disponibles'; });
      FacetFiltersForm.toggleActiveFacets(false);
    } finally {
      if (request === sequence) gridContainer?.removeAttribute('aria-busy');
    }
  }
  window.MqCollectionTypes = { renderPage, syncControls };
  syncControls();
  if (new URLSearchParams(location.search).has('mq_type')) renderPage(location.search.slice(1), null, false);
  document.addEventListener('click', event => {
    const link = event.target.closest('.mq-type-pagination a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); renderPage(new URL(link.href).searchParams.toString());
  });
  document.addEventListener('shopify:section:load', syncControls);
})();
